<template>
    <div v-show="!inLivePage" id="line" >
      <div v-for="line in lines" >
        <div v-if="(incomingCallLineUid === line.uid) && rejectedCall === line.uid" class="notification mask">
          <div class="text-xl">
            <span><strong>Gerade keine Zeit?&nbsp;</strong>Kein Problem.</span>
          </div>
          <div class="btns">
            <button @click.prevent="getInLineAgain(line)" class="btn green">Hinten anstellen</button>
            <button @click.prevent="removeFromLine(line)" class="btn orange">Einkauf beenden</button>
          </div>
        </div>
        <div v-if="(incomingCallLineUid === line.uid) && rejectedCall !== line.uid" class="notification mask">
          <div class="text-xl">
            <span>Du bist dran bei <div class="vendor-name">""{{ line.shop.name }}</div>"</span>
          </div>
          <div class="btns">
            <button @click.prevent="goToLiveChat(line)" class="btn icon green"><span><icon class="icon" name="check"></icon></span><span>Annehmen</span>
            </button>
            <button @click.prevent="rejectCall(line)" class="btn icon orange"><span><icon class="icon" name="times"></icon></span><span>Nicht jetzt</span>
            </button>
          </div>
        </div>
        <transition name="fade" mode="out-in">
          <div class="line-container" v-show="lines.length <= minimumClose || isOpen">
            <div class="mask">
              <div :class="['number', line.shop.is_online ? 'bg-green' : 'bg-grey' ]"><span>{{ line.position_in_line }}</span></div>
              <div class="text">
                <span>Du stehst bei <div class="vendor-name">"{{ line.shop.name }}</div>" an.</span>
                <span v-if="line.shop.is_online" >{{ line.position_in_line }} Person ist noch vor Dir dran</span>
                <span v-if="!line.shop.is_online">{{ line.shop.name }} is gerade offline</span>
              </div>
              <div class="close" @click.prevent="removeFromLine(line)"><icon class="icon" name="times-circle"></icon></div>
            </div>
          </div>
        </transition>
      </div>
      <div class="mask main" v-show="isOpen && lines.length > minimumClose" @click.prevent="isOpen = !isOpen">
        <div class="number bg-green"><span><icon name="chevron-down"></icon></span></div>
        <div class="text opened">
          <span>Wieder verbergen</span>
        </div>
      </div>
      <div class="mask main" v-show="!isOpen && lines.length > minimumClose" @click.prevent="isOpen = !isOpen">
        <div class="number bg-green"><span>{{ lines.length }}</span></div>
        <div class="text closed">
          <span>Du stehst bei "<strong>{{ lines.length }} Händlern</strong>" an.</span>
          <span>Klicke um alle anzuzeigen</span>
        </div>
      </div>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    name: 'lines',
    data () {
      return {
        rejectedCall: '',
        reloadingLines: false,
        isOpen: false,
        minimumClose: 0,
        incomingCallLineUid: null
      }
    },
    mounted () {
      EventBus.$on('sizeBreakPoint', () => {
        this.updateMinClose()
      })
      EventBus.$on('callIncoming', (line) => {
        console.log('lines:line incoming', line.uid)
        if (this.incomingCallLineUid === line.uid) {
          this.rejectedCall = ''
        } else {
          this.incomingCallLineUid = line.uid
        }
      })
      EventBus.$on('callStopped', (line) => {
        if (line.uid === this.incomingCallLineUid) {
          this.incomingCallLineUid = null
          this.rejectedCall = ''
        }
      })
      if (this.prexistentCall) {
        this.setPreExistent()
      }
      this.updateMinClose()
    },
    beforeDestroy () {
      EventBus.$off('callIncoming')
      EventBus.$off('callStopped')
    },
    methods: {
      setPreExistent () {
        this.incomingCallLineUid = this.prexistentCall
        this.rejectedCall = ''
        this.$store.commit('USER_CALL_WAS_WAITING', null)
      },
      onLinePage (line) {
        return this.$route.name === 'liveCall' && this.$route.params['line'] === line.uid
      },
      updateMinClose () {
        var screenWidth = window.innerWidth
        if (screenWidth < 712) {
          this.minimumClose = 0
        } else {
          this.minimumClose = 2
        }
      },
      getInLineAgain (line) {
        const vm = this
        vm.getOutOfLine({
          line: line.uid,
          user: vm.account.uid,
          cb: () => {
            vm.getInLine({shop: line.shop.uid})
            vm.$toasted.success('Sie haben die Warteschlange betreten.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'check'
            })
          },
          errorCb: () => {
            vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'close'
            })
          }
        })
      },
      removeFromLine (line) {
        const vm = this
        vm.getOutOfLine({
          line: line.uid,
          user: vm.account.uid,
          cb: () => {
            vm.$toasted.success('Sie haben die Warteschlange verlassen.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'check'
            })
          },
          errorCb: () => {
            vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'close'
            })
          }
        })
      },
      goToLiveChat (line) {
        this.$store.commit('USER_SET_CURRENT_LINE', line)
        this.$router.push({name: 'liveCall', params: {line: line.uid}})
      },
      rejectCall (line) {
        console.log('rejected')
        this.rejectedCall = line.uid
      },
      ...mapActions([
        'getOutOfLine',
        'getInLine',
        'getLines'
      ])
    },
    computed: {
      ...mapGetters({
        lines: 'user_get_lines',
        currentLine: 'user_get_current_line',
        account: 'auth_get_account',
        inLivePage: 'user_get_in_live_page',
        prexistentCall: 'user_get_prexistent_call'
      })
    },
    watch: {
      prexistentCall: function (value) {
        if (value) {
          this.setPreExistent()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/menus/lines.vue